module.exports = __webpack_public_path__ + "static/media/icon_testresults_lightblue.c698e036.svg";